import { GridCellProps } from '@progress/kendo-react-grid';
import { FC } from 'react';
import GridCellBase from 'src/components/GridCellBase';

const InvoiceLineItemCompleted: FC<GridCellProps> = (props) => {
  const { dataItem } = props;

  const isInvoiceQtyComplete = dataItem.quantityReceived + dataItem.previousQty >= dataItem.poQty;

  return (
    <GridCellBase
      {...props}
      title={isInvoiceQtyComplete ? 'Y' : 'N'}
      className={`text-bold text-center flex justify-center ${
        isInvoiceQtyComplete ? 'bg-success' : 'bg-error'
      } bg-opacity-25`}
      style={{
        textAlign: 'center',
      }}
    >
      <div>
        <span>{isInvoiceQtyComplete ? 'Y' : 'N'}</span>
      </div>
    </GridCellBase>
  );
};

export default InvoiceLineItemCompleted;
